import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap, tap} from 'rxjs/operators';

import * as AuthActions from '../actions/auth.actions';
import { AlertService } from '../../commons/services/alert.service';
import { LaravelUserService } from '../../commons/services/laravel/laravel-user.service';

@Injectable()
export class AuthEffects {

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.login),
      mergeMap(({ username, password }) =>
        this.laravelUserService.login(username, password).pipe(
          map(result => AuthActions.loginCompleted({ currentUser: result.user, token: result.token })),
          tap(({ currentUser }) => {
            if(currentUser.user_roles.includes('rider')) {
              this.router.navigate(['/riders/orders/free']);
            } else{
              this.router.navigate(['/']);
            }
            this.alertService.showConfirmMessage(`Login effettuato con successo`);
          }),
          catchError(error => of(AuthActions.loginFailed({ error })))
        )
      )
    )
  );

  // login$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(AuthActions.login),
  //     mergeMap(({username, password}) =>
  //       this.laravelUserService.login(username, password)
  //         .pipe(
  //           map(result => AuthActions.loginCompleted({currentUser: result.user, token: result.token})),
  //           tap((action) => {
  //             if(action.type === AuthActions.loginCompleted.type) {
  //               this.alertService.showConfirmMessage(`Login effettuato con successo`);
  //             }
  //           }),
  //           catchError(error => of(AuthActions.loginFailed({error}))))
  //     ))
  // );

  // loginRider$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(AuthActions.login),
  //     mergeMap(({ username, password }) =>
  //       this.laravelUserService.login(username, password).pipe(
  //         map(result => {
  //           if (result.user.user_roles.includes('rider')) {
  //             return AuthActions.loginCompleted({ currentUser: result.user, token: result.token });
  //           } else {
  //             return AuthActions.loginFailed({ error: 'Non autorizzato' });
  //           }
  //         }),
  //         tap(action => {
  //           if ('currentUser' in action) {
  //             this.router.navigate(['/riders/orders/free']);
  //             const snackBarRef: any = this.alertService.showConfirmMessage(`Login Rider effettuato con successo`, { duration: 3000 });
  //             snackBarRef.onAction().subscribe(() => {
  //               snackBarRef.dismiss();
  //             });
  //           }
  //         }),
  //         catchError(error => of(AuthActions.loginFailed({ error })))
  //       )
  //     )
  //   )
  // );
  

  // afterLogin$ = createEffect(() => this.actions$.pipe(
  //   ofType(AuthActions.loginCompleted),
  //   tap(() => {
  //     this.router.navigate(['/']);
  //     this.alertService.showConfirmMessage(`Login effettuato con successo`)
  //     // map(() => AuthActions.loadCurrentUser())
  //   })), {dispatch: false}
  // );


  loginError$ = createEffect(() => this.actions$.pipe(
    ofType(AuthActions.loginFailed),
    tap((action) => this.alertService.showErrorMessage(`Errore durante il login`, action.error))
  ), {dispatch: false}
  );

  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.logout),
      mergeMap(({ showConfirm }) => {
        if (showConfirm) {
          return this.alertService.showConfirmDialog('Conferma', `Sei sicuro di voler effettuare il logout?`)
            .pipe(
              mergeMap(confirm => {
                if (confirm) {
                  return of(AuthActions.logoutCompleted()).pipe(
                    tap(() => this.router.navigate(['/login'])),
                    tap(() => this.alertService.showConfirmMessage(`Logout effettuato con successo`))
                  );
                } else {
                  return of(AuthActions.logoutCancelled());
                }
              })
            );
        } else {
          return of(AuthActions.logoutCompleted()).pipe(
            tap(() => this.router.navigate(['/login'])),
            tap(() => this.alertService.showConfirmMessage(`Logout effettuato con successo`))
          );
        }
      })
    )
  );
  

  // afterLogout$ = createEffect(() => this.actions$.pipe(
  //   ofType(AuthActions.logoutCompleted),
  //   tap(() => this.router.navigate(['/login'])),
  //   tap(() => this.alertService.showConfirmMessage(`Logout effettuato con successo`))

  // ), {dispatch: false}
  // );

  currentUser$ = createEffect(() => this.actions$.pipe(
    ofType(AuthActions.loadCurrentUser),
    mergeMap(() =>
      this.laravelUserService.getCurrentUser()
        .pipe(
          map((currentUser) => AuthActions.loadCurrentUserCompleted({currentUser})),
          catchError(error => of(AuthActions.loadCurrentUserFailed({error}))))
    )
  ));


  constructor(
    private actions$: Actions,
    private laravelUserService: LaravelUserService,
    private alertService: AlertService,
    private router: Router
  ) { }
}
